import React from "react";

export default function KpiStatCard({ label, value, subtext, icon, color = "#3b82f6", iconBg = "#eff6ff" }) {
  return (
    <div className="kpi-card" style={{ "--kpi-color": color, "--kpi-icon-bg": iconBg }}>
      <div className="kpi-header">
        <p className="kpi-label">{label}</p>
        <div className="kpi-icon-wrapper">
          {icon}
        </div>
      </div>
      <h3 className="kpi-value">{value}</h3>
      {subtext && <p className="kpi-subtext">{subtext}</p>}
    </div>
  );
}
